// Mirror of pimento/src/components/Orders/utils/fileAcceptance.ts.
// Update both files together.
export const IMAGE_EXTENSIONS = new Set(["jpg", "jpeg", "rjpeg"]);
export const POINTCLOUD_EXTENSIONS = new Set(["las"]);
export const GEOMETRY_EXTENSIONS = new Set([
  "geojson",
  "json",
  "kml",
  "kmz",
  "shp",
  "shx",
  "dbf",
  "prj",
  "zip",
  "csv",
  "pdf",
  "xlsx",
]);

export type UploadCategory = "image" | "pointcloud" | "geometry" | "other";

export function categorizeExtension(ext: string | null | undefined): UploadCategory {
  const e = (ext ?? "").toLowerCase().replace(/^\./, "");
  if (IMAGE_EXTENSIONS.has(e)) return "image";
  if (POINTCLOUD_EXTENSIONS.has(e)) return "pointcloud";
  if (GEOMETRY_EXTENSIONS.has(e)) return "geometry";
  return "other";
}
